// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602251517/js/" + chunkId + "." + {"44":"cd0b1452","225":"f91a4781","481":"12288748","486":"2e42c1fa","770":"62c32777"}[chunkId] + ".0.3551637545383639.chunk.js";
};